module.exports = __webpack_public_path__ + "static/media/inverno.8eda466e.png";